import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  DownloadIcon,
  ScanIcon,
  ShareIcon
} from "../../front-end-global-components/assets/assets";
import FeatureFlagsFallback from "../../front-end-global-components/components/FeatureFlagsFallback/FeatureFlagsFallback";
import Header from "../../front-end-global-components/components/Header/Header";
import { setErrorStatus } from "../../redux/status/actions";
import { getPatientQrDetails } from "../../services/api";
import "./ShowAbdmInfo.css";

function AbdmQr(props) {
  const [qrDataUriLoading, setQrDataUriLoading] = useState(false);
  const [dataUrl, setDataUrl] = useState(null);
  const navigate = useNavigate();

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = dataUrl;
    link.download = "image.jpg";
    link.click();
  };

  const handleShare = async () => {
    const blob = await (await fetch(dataUrl)).blob();
    const file = new File([blob], "ABHA QR.png", {
      type: blob.type
    });
    if (!!navigator && navigator?.canShare?.({ files: [file] })) {
      await navigator?.share({
        title: "Ninto",
        text: "Ninto - ABHA ADDRESS QR",
        url: window.location.href,
        files: [file]
      });
    }
  };

  const getData = async () => {
    setQrDataUriLoading(true);
    try {
      const { auth, patients } = props;

      const { currentProfile, accessToken } = patients;

      if (typeof accessToken?.[currentProfile]?.token !== "string") {
        setErrorStatus({
          code: "custom",
          message: "Invalid accessToken or requestId or reason"
        });
        return;
      }

      const result = await getPatientQrDetails(
        auth.data.accessToken,
        accessToken?.[currentProfile]?.token,
        currentProfile
      );

      if (
        result?.success === true &&
        result?.data &&
        typeof result?.data === "string"
      ) {
        setDataUrl(result.data);
      } else {
        console.warn("custom", "failed to fetch");
      }
    } catch (error) {
      console.error(error);
      setErrorStatus({
        code: "custom",
        message: "Unable to get QR details"
      });
    }
    setQrDataUriLoading(false);
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.patients.accessToken]);

  const data = [
    ...(dataUrl
      ? [
          {
            title: "download",
            click: () => handleDownload(),
            "data-cy": "ABHA-QR-DOWNLOAD-BUTTON",
            icon: <DownloadIcon />,
            name: "Download"
          }
        ]
      : []),

    {
      title: "scan",
      click: () => navigate("/scanClinic"),
      "data-cy": "ABHA-QR-SCAN-BUTTON",
      icon: <ScanIcon />,
      name: "Registration"
    },

    ...(dataUrl
      ? [
          {
            title: "share",
            click: () => handleShare(),
            "data-cy": "ABHA-QR-SHARE-BUTTON",
            icon: <ShareIcon />,
            name: "Share"
          }
        ]
      : [])
  ];

  return (
    <div className="inherit-parent-height">
      <Header
        title="ABHA Address"
        backButtonOnClick={() => {
          navigate(-1);
        }}
        supportIconOnClick={() => {
          navigate("/query");
        }}
        incident={props.app.featureFlags?.incident?.patients}
        incidentOnClick={() => {
          navigate("/incidents");
        }}
      />

      {!props.app.featureFlags?.abhaService && (
        <FeatureFlagsFallback height={"remaining-body-height"} />
      )}

      {props.app.featureFlags?.abhaService && (
        <>
          <div className="inherit-parent-width text-align-center padding-larger">
            ABHA ADDRESS INFORMATION
          </div>
          <main className="display-flex flex-justify-content-center overflow-hidden padding-top-larger padding-bottom-larger position-relative ">
            {qrDataUriLoading === true ? (
              <div className="background-color-white padding-left-default padding-right-default padding-top-small padding-bottom-small border-radius-default ">
                <div className="loading-spinner" data-cy="LOADING-SPINNER" />
              </div>
            ) : qrDataUriLoading === false && dataUrl ? (
              <div className="flex-justify-content-center ">
                <img
                  className="inherit-parent-height adaptive-width-for-ABHA-CARD"
                  alt="qr"
                  src={dataUrl}
                  data-cy="ABHA-QR"
                />
              </div>
            ) : (
              <p>No QR code Details</p>
            )}
          </main>
          {qrDataUriLoading === false && (
            <div className="display-flex inherit-parent-width overflow-hidden flex-justify-content-space-between border-top-2px-solid-e5e5e5 position-absolute position-bottom-0">
              {data.map((data, index) => (
                <div
                  key={index}
                  style={{
                    width: "124px"
                  }}
                  className="padding-left-larger padding-right-larger padding-top-default padding-bottom-default display-flex flex-direction-column flex-align-items-center flex-justify-content-center"
                  data-cy={data?.["data-cy"]}
                  onClick={data.click}
                >
                  <div>{data.icon}</div>
                  <div className="">{data.name}</div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  patients: state.patients,
  app: state.app
});

export default connect(mapStateToProps)(AbdmQr);
